module.exports = __webpack_public_path__ + "static/media/his.3959fde3.png";